/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                $(window).scroll(function () {
                    var scroll = $(window).scrollTop();
                    var hero = $('.hero-image');

                    hero.css({
                        'background-position': '50% ' + (-0.1 * scroll) + 'px',
                    });

                    if (scroll >= 50) {
                        $('.top').addClass('scroll');
                    } else {
                        $('.top').removeClass('scroll');
                    }
                });

                $(window).resize(function () {
                    var width = $(window).innerWidth();

                    if ($('.primary-navigation').hasClass('showMenu') && width >= 992) {
                        $('.primary-navigation').removeClass('showMenu');
                        $('.hamburger').toggleClass("isActive");
                    }
                });

                $('.search-button').on('click', function () {
                    $('#searchField').toggleClass('show');
                    $(this).toggleClass('active');

                    if ($('.menu-item-has-children').hasClass('active')) {
                        $('.menu-item-has-children').removeClass('active');
                        $('.menu-item-has-children').find('.sub-menu').removeClass('open');
                    }
                });

                $('.menu-item-has-children').on('click', function () {
                    $(this).toggleClass('active');
                    $(this).find('.sub-menu').toggleClass('open');

                    $('.menu-item-has-children.active').not(this).removeClass('active');
                    $('.menu-item-has-children').not(this).find('.sub-menu').removeClass('open');

                    if ($('.search-box').hasClass('show')) {
                        $('.search-box').removeClass('show');
                    }
                });

                $('.menu-item-has-children a').on('hover', function () {
                    $(this).parent().toggleClass('hover');
                });

                $(".hamburger").click(function () {
                    $(this).toggleClass("isActive");
                    $('.primary-navigation').toggleClass('showMenu');
                });

                $('.footer-newsletter .gform_button').attr('value', '');

                $('#search-form').on('submit', function (e) {
                    e.preventDefault();
                    console.log('sssssubmit');
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.report-cards').offset().top - ($('.top.scroll').outerHeight() + 20)
                    }, 1000);
                });

                //LOAD MORE CONTENT
                var $item = $(".archive-container").find('.item').not('.contact-card');
                var $contactCard = $(".archive-container").find('.item.contact-card');

                if ($item.length > 6) {
                    $(".loadMore").show();
                }

                $item.slice(0, 6).slideDown();
                $contactCard.slideDown();

                $($item).each(function () {
                    var $index = $(this).index();
                    var $reversedIndex = ($item.length - $item.index(this));
                    $(this).find('.pod-nr').html($reversedIndex);
                });

                $("#loadMore").on('click', function (e) {
                    e.preventDefault();

                    var $itemHidden = $(".archive-container").find('.item:hidden');
                    $itemHidden.slice(0, 3).slideDown(50);

                    if ($itemHidden.length <= 3) {
                        $(".loadMore").hide();
                    } else {
                        $(".loadMore").show();
                    }

                    $('html,body').animate({
                        scrollTop: $(this).offset().top - 100
                    }, 500);

                });


                //FILTER CONTENT

                var totalListSize = $(".card-item").size();
                $('.result .filter-num').html(totalListSize);
                $('.result .total-num').html(totalListSize);

                //FILTER BY SEARCH


                $('#search').keyup(function () {
                    var val = '^(?=.*\\b' + $.trim($(this).val()).split(/\s+/).join('\\b)(?=.*\\b') + ').*$',
                        reg = RegExp(val, 'i'),
                        text;

                    $item.show().filter(function () {
                        text = $(this).text().replace(/\s+/g, ' ');
                        return !reg.test(text);
                    }).hide();

                    var filterListSize = $(".report-cards .item:visible").size();
                    $('.result .filter-num').html(filterListSize);
                    $('.result .total-num').html(totalListSize);
                    $(".loadMore").hide();

                    if (filterListSize === 0) {
                        $('.no-result').show();
                    } else {
                        $('.no-result').hide();
                    }
                });

                $('#search').click(function () {
                    $(".filter-alt .selected").trigger("click");
                });

                //FILTER ON CLICK

                var $termMeta = $('.term-meta');
                var $termMetaTitle = $('.term-meta__title');
                var $termMetaDescription = $('.term-meta__description');
                $('.filter-alt li').on('click', function (e) {
                    e.preventDefault();

                    var $spinner = $('.filters__spinner');
                    $spinner.addClass('filters__spinner--active');

                    var $taxonomyList = $(this).closest('.taxonomyList');
                    if ($taxonomyList.hasClass('taxonomyList--single-choice')) {
                        $taxonomyList.find('.selected').removeClass('selected');
                    }

                    $('#search').val('');

                    var content = $(".content .main .report-cards");
                    // var taxonomy = $(this).attr('data-id');
                    var action = $('#filters').data('action');
                    var area = [];
                    var year = [];
                    var author = [];
                    var category = [];
                    var studyType = [];

                    var historicalTheme = [];
                    var historicalOrganisation = [];
                    var historicalYear = [];
                    var historicalDocumentType = [];

                    if ($(this).is('.selected:not([data-id="author"])')) {
                        $(this).removeClass('selected');
                    } else {
                        $(this).addClass('selected');
                    }

                    var title = $(this).hasClass('selected') ? $(this).data('termTitle') : '';
                    var description = $(this).hasClass('selected') ? $(this).data('termDescription') : '';

                    $('.selected[data-id="author"]').not(this).removeClass('selected');
                    author.pop($('.selected[data-id="author"]').not(this).html());

                    $('.selected[data-id="area"]').each(function () {
                        area.push($(this).html());
                    });

                    $('.selected[data-id="year"]').each(function () {
                        year.push($(this).html());
                    });

                    $('.selected[data-id="author"]').each(function () {
                        author.push($(this).html());
                    });

                    $('.selected[data-id="category"]').each(function () {
                        category.push($(this).html());
                    });

                    $('.selected[data-id="study-type"]').each(function () {
                        studyType.push($(this).html());
                    });

                    // Historical reports taxonomies
                    $('.selected[data-id="historical-organisation"]').each(function () {
                        historicalOrganisation.push($(this).html());
                    });

                    $('.selected[data-id="historical-theme"]').each(function () {
                        historicalTheme.push($(this).html());
                    });
                    $('.selected[data-id="historical-year"]').each(function () {
                        historicalYear.push($(this).html());
                    });

                    $('.selected[data-id="historical-document-type"]').each(function () {
                        historicalDocumentType.push($(this).html());
                    });

                    $.ajax({
                        url: ajaxtaxonomy.ajaxtaxurl,
                        type: 'POST',
                        data: {
                            action: action ? action : 'ajax_taxonomy',
                            category: category,
                            area: area,
                            year: year,
                            author: author,
                            studyType: studyType,
                            historicalYear: historicalYear,
                            historicalTheme: historicalTheme,
                            historicalOrganisation: historicalOrganisation,
                            historicalDocumentType: historicalDocumentType,
                        },
                        success: function (data) {
                            $spinner.removeClass('filters__spinner--active');
                            $termMeta.removeClass('term-meta--active');
                            $termMetaTitle.html(title);
                            $termMetaDescription.html(description);

                            if (title || description) {
                                $termMeta.addClass('term-meta--active');
                            }

                            content.empty();
                            var reports = content.append(data);

                            if (year) {
                                var sortedReports = reports.find('.item');
                                sortedReports.sort(function (a, b) {
                                        var aCardNumber = $(a).find('.card-number').length > 0 ? $(a).find('.card-number').text() : '0';
                                        var bCardNumber = $(b).find('.card-number').length > 0 ? $(b).find('.card-number').text() : '0';

                                        if (aCardNumber == bCardNumber) {
                                            return 0;
                                        }

                                        if (aCardNumber > bCardNumber) {
                                            return -1;
                                        }

                                        return 1;
                                    }
                                );
                                content.empty();
                                content.append(sortedReports);
                            }

                            var filterListSize = $(".card-item").size();

                            $('.result .filter-num').html(filterListSize);
                            $('.result .total-num').html(totalListSize);

                            $(".card-item").slice(0, 6).show();

                            $('#search').keyup(function () {
                                var val = '^(?=.*\\b' + $.trim($(this).val()).split(/\s+/).join('\\b)(?=.*\\b') + ').*$',
                                    reg = RegExp(val, 'i'),
                                    text;

                                $(".card-item").show().filter(function () {
                                    text = $(this).text().replace(/\s+/g, ' ');
                                    return !reg.test(text);
                                }).hide();

                                var filterListSize = $(".report-cards .item:visible").size();
                                $('.result .filter-num').html(filterListSize);
                                $('.result .total-num').html(totalListSize);
                                $(".loadMore").hide();

                                if (filterListSize === 0) {
                                    $('.no-result').show();
                                } else {
                                    $('.no-result').hide();
                                }
                            });

                            if ($(".card-item:hidden").length === 0) {
                                $(".loadMore").hide();
                            } else {
                                $(".loadMore").show();
                            }

                        }
                    });

                });

                $('#is-select').show();

                $.fn.ulSelect = function () {
                    var ul = $('#is-select');

                    if (!ul.hasClass('taxonomySelect')) {
                        ul.addClass('taxonomySelect');
                    }
                    // SVG arrow
                    var arrow = '<svg id="ul-arrow" xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" viewBox="0 0 32 32"><line stroke-width="1" stroke="#449FDB" opacity=""/><path d="M4.131 8.962c-0.434-0.429-1.134-0.429-1.566 0-0.432 0.427-0.432 1.122 0 1.55l12.653 12.528c0.434 0.429 1.133 0.429 1.566 0l12.653-12.528c0.432-0.429 0.434-1.122 0-1.55s-1.136-0.429-1.566-0.002l-11.87 11.426-11.869-11.424z" fill="#55c0d5"/></svg>';
                    $('li:first-of-type', this).addClass('active').append(arrow);
                    $(this).on('click', 'li', function (event) {

                        if ($('#sel--taxonomySelect').length) {
                            $('#sel--taxonomySelect').remove();
                        }

                        ul.before('<div id="sel--taxonomySelect">');
                        var selected = $('#sel--taxonomySelect');
                        $('li #ul-arrow', ul).remove();

                        ul.toggleClass('active');
                        ul.children().removeClass('active');
                        $(this).toggleClass('active');

                        var selectedText = $(this).text();
                        if (ul.hasClass('active')) {
                            selected.text(selectedText).addClass('active').append(arrow);
                        } else {
                            selected.text('').removeClass('active');
                            $('li.active', ul).append(arrow);
                        }
                    });

                    $(document).on('click', function (event) {
                        if ($('ul.taxonomySelect').length) {
                            if ($('ul.taxonomySelect').has(event.target).length > 0) {
                                return;
                            } else {
                                $('ul.taxonomySelect').removeClass('active');
                                $('#sel--taxonomySelect').removeClass('active').text('');
                                $('#ul-arrow').remove();
                                $('ul.taxonomySelect li.active').append(arrow);
                            }
                        }
                    });
                };

                // Run
                $('#is-select').ulSelect();

                var active_sv;
                var active_en;

                if (window.location.href.indexOf('utlysningar') > -1) {
                    active_sv = $('.widget-category.current_type a:contains("Utlysningar")');
                    active_en = $('.widget-category.current_type a:contains("Announcements")');
                } else if (window.location.href.indexOf('blog') > -1) {
                    active_sv = $('.widget-category.current_type a:contains("Blogg")');
                    active_en = $('.widget-category.current_type a:contains("Blog")');
                } else if (window.location.href.indexOf('press') > -1) {
                    active_sv = $('.widget-category.current_type a:contains("Press")');
                    active_en = $('.widget-category.current_type a:contains("Press")');
                } else if (window.location.href.indexOf('bistandsanalys') > -1) {
                    active_sv = $('.widget-category.document_type a:contains("Årsrapporter")');
                    active_en = $('.widget-category.document_type a:contains("Annual reports")');
                }

                if (active_sv !== undefined) {
                    active_sv.addClass('active');
                }

                if (active_en !== undefined) {
                    active_en.addClass('active');
                }

                $('.widget-category.current_type a').on('click', function (e) {
                    e.preventDefault();
                    var content = $(".content .main .news-list");
                    var terms = $(this).html();

                    $(this).addClass('active');
                    $('.widget-category.current_type a').not(this).removeClass('active');

                    $('h2 .title').html(terms);

                    $.ajax({
                        url: ajaxtaxonomy.ajaxtaxurl,
                        type: 'POST',
                        data: {
                            action: 'ajax_taxonomy_current',
                            terms: terms
                        },
                        success: function (data) {
                            content.empty();
                            content.append(data);

                            $(".news-item").slice(0, 6).show();

                            if ($(".news-item:hidden").length === 0) {
                                $(".loadMore").hide();
                            } else {
                                $(".loadMore").show();
                            }
                        }
                    });
                });

                $('.widget-category.document_type a').on('click', function (e) {
                    e.preventDefault();
                    var content = $(".content .main .news-list");
                    var terms = $(this).html();

                    $(this).addClass('active');
                    $('.widget-category.document_type a').not(this).removeClass('active');

                    $('h2 .title').html(terms);

                    $.ajax({
                        url: ajaxtaxonomy.ajaxtaxurl,
                        type: 'POST',
                        data: {
                            action: 'ajax_taxonomy_docs',
                            terms: terms
                        },
                        success: function (data) {
                            content.empty();
                            content.append(data);

                            $(".news-item").slice(0, 6).show();

                            if ($(".news-item:hidden").length === 0) {
                                $(".loadMore").hide();
                            } else {
                                $(".loadMore").show();
                            }
                        }
                    });
                });


                //TOGGLE CONTACT CARD INFO
                $(".card-cta").click(function () {
                    event.preventDefault();
                    $(this).parent().toggleClass('active');
                });

                $(".download-link").each(function () {
                    var $pdf = $(this).attr("href").match(/\.(pdf)$/i);
                    var $ppt = $(this).attr("href").match(/\.(ppt|pptx)$/i);

                    if ($pdf) {
                        $(this).addClass('pdf');
                    }

                    if ($ppt) {
                        $(this).addClass('ppt');
                    }
                });

                $('.ext-link').each(function () {
                    if ($(this).is('[href*="mailto"')) {
                        $(this).addClass('email');
                    } else {
                        $(this).addClass('link');
                    }
                });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
